<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" class="title">
          <app-editor :value="JSON.parse(data.description)" :editable="false" />
        </v-col>
        <v-col cols="12" class="body-2">
          <app-editor
            :value="JSON.parse(data.question_group.questions[0].content)"
            :editable="false"
          />
        </v-col>
        <v-col
          v-show="
            data.question_group.questions[0].question_doc_file ||
            data.question_group.questions[0].question_file
          "
          cols="12"
          class="text-center"
        >
          <div class="d-flex mx-auto" style="max-width: 300px">
            <app-audio-player short :src="data.question_group.questions[0].question_file" />
          </div>
          <div v-if="data.question_group.questions[0].question_doc_file" class="pt-4 text-end">
            <a :href="data.question_group.questions[0].question_doc_file" target="_blank" donwload>
              <v-btn text class="text-capitalize">
                Download Document
                <v-icon right> $vuetify.icons.appDownload </v-icon>
              </v-btn>
            </a>
          </div>
        </v-col>
        <v-col cols="12" class="mt-n1">
          <app-new-feedback
            :disabled="answered"
            :closable="false"
            noIncrease
            showPlaceholder
            :content="answers.length ? answers[0].content : ''"
            :src="answers.length ? answers[0].audio_file : ''"
            @new-comment="onNewComment"
            :commentDialog="commentDialog"
          >
            <template #title-text>
              <div class="mb-5 text-center">
                <div class="d-inline-block pl-2">
                  <div
                    style="color: #29284c; font-size: 28px"
                    class="px-2 py-1 rounded-lg font-weight-medium"
                  >
                    Student's Answer
                  </div>
                </div>
              </div>
            </template>
          </app-new-feedback>
        </v-col>
        <v-col cols="12">
          <app-comment-group
            divider
            :uuid="data.comment_group"
            @comment-dialog="commentDialog = $event"
          />
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn
            v-if="isTeacher"
            class="white--text ml-2 text-capitalize"
            color="#29284c"
            :loading="loadingAssign"
            :disabled="finished || disabled"
            @click="assign(data.uuid)"
          >
            {{
              finished || disabled
                ? "Already assigned"
                : `Assign to ${student.first_name} ${student.last_name}`
            }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" absolute />
    <app-qualification
      v-if="isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      absolute
      @new-qual="qualification = $event"
    />
  </div>
</template>
<script>
import homeworkLessonMixin from "@/mixins/homeworkLessonMixin";
import NewFeedback from "../../NewFeedback.vue";
import AudioPlayer from "../../AudioPlayer.vue";

export default {
  components: {
    appNewFeedback: NewFeedback,
    appAudioPlayer: AudioPlayer,
  },
  mixins: [homeworkLessonMixin],
  methods: {
    onNewComment(payload) {
      this.answers.splice(0, 1, {
        ...this.answers[0],
        content: JSON.stringify(payload.text),
        audio_file: payload.audioBlob,
      });
      this.save();
    },
  },
};
</script>
